import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const adminManagementApi = createApi({
  reducerPath: 'admin-management',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['AdminManagement'],
  endpoints: (builder) => ({
    getAdmins: builder.query({
      query: ({ pageno, limit, search, status, sortBy, sortOrder }) => {
        const params = new URLSearchParams();

        if (pageno !== undefined) params.set('pageno', pageno);
        if (limit) params.set('limit', limit);
        if (search) params.set('search', search);
        if (status) params.set('status', status);
        if (sortBy) params.set('sortBy', sortBy);
        if (sortOrder) params.set('sortOrder', sortOrder);

        return { url: `admin/all?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['AdminManagement'],
    }),
    createAdmin: builder.mutation({
      query: (body) => ({ url: 'admin/create', method: 'POST', body }),
      invalidatesTags: ['AdminManagement'],
    }),
    updateAdmin: builder.mutation({
      query: ({ id, body }) => ({ url: `admin/update/${id}`, method: 'PUT', body }),
      invalidatesTags: ['AdminManagement'],
    }),
    updateAdminStatus: builder.mutation({
      query: (id) => ({
        url: `admin/status/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
      }),
      invalidatesTags: (result, error) => (error ? [] : ['AdminManagement']),
    }),
  }),
});

export const {
  useGetAdminsQuery,
  useCreateAdminMutation,
  useUpdateAdminMutation,
  useUpdateAdminStatusMutation,
} = adminManagementApi;